<template>
  <div>
    <v-container grid-list-md pt-0> <v-layout row wrap>
        <v-flex 
          xs12 md6 
          v-for="(item, index) in billingItems" 
          :key="index"
        >
          <ElectronicBillingCard v-if="item" :image="item"></ElectronicBillingCard>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import ElectronicBillingCard from "./ElectronicBillingCard";
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";


export default {
  computed: {
    ...mapGetters(["externalElectronicBilling", "externalElectronicBillingHistory","loadingExternal","agency"]),
    billingItems() {
      return [
        this.externalElectronicBilling,
        this.externalElectronicBillingHistory
      ].filter(item => item !== undefined);
    }
  },
  mounted() {
    this.$store.dispatch("external");
  },
  components: {
    ElectronicBillingCard
  },
  methods:{},
  watch: {
    loadingExternal(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando configuración");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val){
      this.$store.dispatch("external");
    }
  },
  data() {
    return {};
  }
};
</script>